import { Music24PlanTier, music24PlanCapabilities } from 'fym-shared/src/music24/music24Plans';

/** The periods of the Performance picker, in days (design social-connectors b1). */
export const SOCIAL_PERIODS = [7, 28, 90, 180, 365] as const;
export type SocialPeriodDays = (typeof SOCIAL_PERIODS)[number];

/** The default period, and the period of the Channels growth line. */
export const SOCIAL_DEFAULT_DAYS: SocialPeriodDays = 28;

/** The default period on a plan whose history is shorter than 28 days (Free). */
export const SOCIAL_SHORT_DAYS: SocialPeriodDays = 7;

/** 28 days, or 7 days when the history window of the plan is shorter than 28 days. */
export function defaultSocialDays(historyDaysLimit: number): SocialPeriodDays {
  return historyDaysLimit < SOCIAL_DEFAULT_DAYS ? SOCIAL_SHORT_DAYS : SOCIAL_DEFAULT_DAYS;
}

/** True when the plan does not keep this many days. The server limits `days` to the same window. */
export function isSocialPeriodLocked(days: number, historyDaysLimit: number): boolean {
  return days > historyDaysLimit;
}

// Plug costs the most ($299), so it is last: a cheaper plan with the same history always wins.
const PAID_TIERS_CHEAPEST_FIRST: readonly Music24PlanTier[] = ['artist', 'pro', 'manager', 'label', 'plug'];

/** The cheapest plan that keeps this many days: the upgrade prompt names it (design b2). */
export function planForSocialDays(days: number): Music24PlanTier {
  return PAID_TIERS_CHEAPEST_FIRST.find((tier) => music24PlanCapabilities[tier].historyDaysLimit >= days) ?? 'label';
}
